/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Reliability_FailoverInputs */

const en_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovered by failover`)
};

const zh_hans1_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动切换后恢复`)
};

const pt_br2_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperado por failover`)
};

const es_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperadas por el respaldo automático`)
};

const fr_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupéré par basculement`)
};

const de_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per Failover aufgefangen`)
};

const ru_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановлено автоматическим переключением`)
};

const it_measure_reliability_failover = /** @type {(inputs: Measure_Reliability_FailoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperate dal failover`)
};

/**
* | output |
* | --- |
* | "Recovered by failover" |
*
* @param {Measure_Reliability_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_failover = /** @type {((inputs?: Measure_Reliability_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_failover(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_failover(inputs)
	if (locale === "es") return es_measure_reliability_failover(inputs)
	if (locale === "fr") return fr_measure_reliability_failover(inputs)
	if (locale === "de") return de_measure_reliability_failover(inputs)
	if (locale === "ru") return ru_measure_reliability_failover(inputs)
	if (locale === "it") return it_measure_reliability_failover(inputs)
	return en_measure_reliability_failover(inputs)
});